import { render } from "./FolderView.vue?vue&type=template&id=d3ae3992&scoped=true&ts=true"
import script from "./FolderView.vue?vue&type=script&lang=ts"
export * from "./FolderView.vue?vue&type=script&lang=ts"

import "./FolderView.vue?vue&type=style&index=0&id=d3ae3992&scoped=true&lang=less"

import exportComponent from "C:\\Users\\adavi\\Documents\\CosmicDS\\minids\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3ae3992"]])

export default __exports__